import styled from 'styled-components';

export const LinkToUsTableSection = styled.div`
    width: 100%;
    background: #F1FEFF;
    padding-bottom: 50px;
    th{
        color: rgb(0 0 0 / 80%);
        text-align: center;
        font-size: 18px;
        font-family: 'Jost', sans-serif;
        font-weight: 700;
        line-height: 24px;
        border: 1px solid #000;
        border-top: none;
        border-right: none;
        background: #fff;
        border-bottom: 1px solid #707070;

        &:first-child{
            border-radius: 15px 0px 0px 0px;
            border-left: none;
        }

        &:last-child{
            border-radius: 0px 15px 0px 0px;
        }
    }
    td{
        border-bottom: none;
        border-left: 1px solid #707070;
        max-width: 271px;
        
        &:first-child{
            border-left: none;
            border-radius: 0 0 0 20px;
        }
        
        &:last-child{
            border-radius: 0 0 20px 0;
        }
    }
    tr{
        background/: transparent;
        border-bottom: 1px solid #707070;
        &:last-child{
            border-bottom: none;
        }

        &.table-row-border{
            border-bottom: none;
            border-radius: 0 0 0 15px;
            td{
                border-bottom: none;
                border-radius: 0 0 15px 15px;
            }
        }
    }
`;

export const LinkToUsTableTitle = styled.div`
    max-width: 601px;
    margin: 0 auto;
    text-align: center;
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    font-family: 'Jost', sans-serif;
    line-height: 30px;
    margin-bottom: 30px;

    @media screen and (max-width: 767px){
        font-size: 18px;
        line-height: 28px;
    }
`;

export const ContactButton = styled.a`
    color: #01606F;
    padding-left: 5px;
    text-decoration: none;
    outline: none;
    cursor: pointer;
    transition: 0.5s all ease-in-out;
    &:hover{
        color: #f7931e;
    }

    .contact-now-btn {
        background: transparent;
        border: none;
        border-radius: 0;   
        padding: 5px 10px 5px 15px;
        color: #01606F;
        text-decoration: none;
    }
`;

export const Table = styled.table`
    margin-bottom: 0px;
    
    .link-to-us-table{
        border: 1px solid #000;
        margin-bottom: 0px 0 !important;
    }
`;

export const Thead = styled.thead`
    td{
        padding: 20px;
    }
`;

export const Tbody = styled.tbody`
    border-bottom: none;
    
    .table-row-data{
        text-align: center;
        vertical-align: middle;
    }
`;

export const TableRow = styled.tr`
    padding: 20px !important;
`;

export const TableHead = styled.th`
    padding: 20px !important;
`;
export const TableDiv = styled.td`
    padding: 20px !important;
`;

export const ImageSize = styled.div`
    text-align: center;
    margin-bottom: 10px;
    color: #000000;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 26px;
    
    &:last-child{
        margin-bottom: 0px;
    }
`;

export const ImageSizeStrong = styled.strong`
    color: #000000;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 26px;
    display: block;
`;

export const ImageShow = styled.div`
    display: block;
    max-width: 242px;
    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const DownloadButton = styled.div`
    display: block;
`;

export const DownloadLinkButton = styled.div`

    &.download-link-large-btn{
        background: transparent;
        color: #01606F;
        font-size: 18px;
        font-family: 'Jost', sans-serif;
        font-weight: 600;
        line-height: 26px;
        cursor: pointer;
    }

    &.download-link-small-btn{
        background: transparent;
        color: #01606F;
        font-size: 18px;
        font-family: 'Jost', sans-serif;
        font-weight: 400;
        line-height: 26px;
        cursor: pointer;
        margin-top: 10px;
    }
`;

export const TableHtmlCode = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
`;

export const TableHtmlCodeBox = styled.div`

`;

export const TableHtmlCodeWrap = styled.div`
    min-width: 271px;
    width: 100%;
    background: #FFFFFF;
    padding: 10px;
    margin-top: 10px;
    border: 1px solid #707070;
    font-size: 14px;
    color: rgb(0 0 0 / 80%);
    font-family: 'Jost', sans-serif;
    line-height: 20px;
    font-weight: 400;
    word-wrap: break-word;
    text-align: left;

    @media screen and (max-width: 991px){
        min-width: 170px;
    }
`;

export const TableHtmlCodeHeading = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CodeCopyButton = styled.div`
    color: #01606F;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 20px;
    cursor: pointer;
`;
export const TableHtmlCodeTitle = styled.h5`
    color: rgb(0 0 0 / 80%);
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 20px;
    
`;
export const TableMain = styled.div`
    max-width: 996px;
    margin: 0 auto;
    border: 1px solid #000;
    border-radius: 15px;
    overflow: hidden;

    .table{
        margin-bottom: 0rem !important;
    }
`;